import { APPLICATION_FORM } from '@/utility/constants';

export default {
  computed: {
    isLSZTemplateActive() {
      const bootstrapFormSettings = this.$store.getters
        .bootstrap?.settings?.uiConfig?.applicationForm;
      const { template } = bootstrapFormSettings;
      return template === APPLICATION_FORM.TEMPLATE.CITY_OF_ZURICH;
    },
  },
};
